/**
 * Filtra las propiedades de un objeto 'visita' según una lista de nombres de entrada.
 *
 * @param {Object} visita - El objeto que contiene los datos de la visita.
 * @param {string[]} inputNames - Un arreglo de nombres de propiedades que se desean extraer del objeto 'visita'.
 * @returns {Object} Un nuevo objeto que solo incluye las propiedades especificadas en 'inputNames' si existen en 'visita'.
 */
export const filterVisitaData = (visita, inputNames) => {
    return inputNames.reduce((acc, name) => {
        if (visita.hasOwnProperty(name)) {
            acc[name] = visita[name];
        }
        return acc;
    }, {});
};

/**
 * Obtiene un arreglo de nombres de los inputs a partir de una lista.
 * Si `isGroup` es verdadero, se asume que cada elemento del arreglo es un grupo que contiene un arreglo de inputs,
 * y se extraen los nombres de todos los inputs de todos los grupos.
 * Si `isGroup` es falso, se extraen los nombres directamente de cada elemento del arreglo.
 *
 * @param {Array} arr - Arreglo de elementos o grupos de inputs.
 * @param {boolean} [isGroup=false] - Indica si el arreglo contiene grupos de inputs.
 * @returns {Array<string>} Arreglo con los nombres de los inputs.
 */
export const getInputNames = (arr, isGroup = false) => {
    return isGroup
        ? arr.flatMap(g => g.inputs.map(i => i.name))
        : arr.map(i => i.name);
};
